import { render, staticRenderFns } from "./FantasyCardCoach.vue?vue&type=template&id=36cfb4cd&"
import script from "./FantasyCardCoach.vue?vue&type=script&lang=js&"
export * from "./FantasyCardCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports